// extracted by mini-css-extract-plugin
export var dateTimeButton = "_dv-1";
export var dateTimeButtonsContainer = "_dv-6";
export var dateTimeInputContainer = "_dv-7";
export var dateTimeWrapper = "_dv-8";
export var disabledTile = "_dv-0";
export var header = "_dv-2";
export var line = "_dv-3";
export var snoozeOption = "_dv-4";
export var time = "_dv-5";
export var todayTile = "_dv-9";
export var wrapper = "_dv-a";